module.exports = __webpack_public_path__ + "static/img/bg-fr.37055c4d.png";